import { Select } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { lighten } from 'polished';

import { FormPublicDesignFragment } from '../../graphql/fragment/form.public.fragment';

interface Props {
  design: FormPublicDesignFragment;
  onChange: any;
  value: string;
  children?: any;
  name: string;
  label: any;
  error?: any;
}

const Field = styled(Select)<{
  design: FormPublicDesignFragment;
  error?: any;
}>`
  &.MuiInput-root {
    width: 100%;
    background: transparent;

    & .MuiSelect-select {
      color: ${({ design }) => design.colors.answer};
    }

    .MuiSvgIcon-root {
      fill: white;
    }
    & MuiSelect-select {
      background: none !important;
      color: ${({ design }) => design.colors.answer};
    }
    &:hover::before {
      border-width: 1px;
      border-color: ${({ design }) => lighten(0.2, design.colors.button)};
    }
    &::before {
      border-width: 1px;
      border-color: ${({ design }) => design.colors.question};
    }
    &::after {
      border-width: 1px;
      border-color: ${({ design, error }) =>
        error ? '' : design.colors.button};
    }
  }
`;

export const StyledSelect = (props: Props) => {
  return <Field {...props} />;
};
